import { Card } from "../ui/card";
import { Input } from "../ui/input";

export default function ScoreInputCard({
  scoreUs,
  scoreThem,
  opponentName,
  onChangeUs,
  onChangeThem,
  totalGoalsByPlayer,
}) {
  const result =
    scoreUs > scoreThem ? "vittoria" : scoreUs < scoreThem ? "sconfitta" : "pareggio";
  const resultColor =
    scoreUs > scoreThem
      ? "text-emerald-600"
      : scoreUs < scoreThem
      ? "text-red-600"
      : "text-amber-600";
  const goalsMismatch = totalGoalsByPlayer !== Number(scoreUs);

  return (
    <Card className="p-5 border-slate-200">
      <div className="flex items-center justify-center gap-6">
        <div className="text-center">
          <div className="label-eyebrow">Noi</div>
          <Input
            type="number"
            min="0"
            value={scoreUs}
            onChange={(e) => onChangeUs(e.target.value)}
            className="text-center text-3xl font-heading font-bold h-16 w-20 mt-1"
            data-testid="score-us"
          />
        </div>
        <div className="font-heading font-bold text-3xl text-slate-300">—</div>
        <div className="text-center">
          <div className="label-eyebrow">{opponentName || "Avversari"}</div>
          <Input
            type="number"
            min="0"
            value={scoreThem}
            onChange={(e) => onChangeThem(e.target.value)}
            className="text-center text-3xl font-heading font-bold h-16 w-20 mt-1"
            data-testid="score-them"
          />
        </div>
      </div>
      <div
        className={`text-center mt-3 text-sm font-medium uppercase tracking-wider ${resultColor}`}
      >
        {result}
        {goalsMismatch && (
          <span className="block text-xs text-slate-400 mt-1 normal-case tracking-normal">
            Attenzione: somma dei goal individuali ({totalGoalsByPlayer}) ≠ {scoreUs}
          </span>
        )}
      </div>
    </Card>
  );
}
